<template>
  <div class="first-Bar">
    <router-link
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      v-for="(item, index) in list"
      :key="item.id"
      class="card"
      :style="`grid-area: card-${index + 1}`"
    >
      <div class="image-block">
        <span class="category">{{ item.sub_category.name }}</span>
        <ImageContainer
          :src="item.image.medium"
          :alt="item.title"
          :thumb="item.image.thumbnail"
          class="image"
        />
      </div>
      <div class="about">
        <span class="decor-block"></span>
        <span class="category-alter">{{ item.sub_category.name }}</span>
        <h1 class="text">
          {{ item.title }}
        </h1>
        <h2 class="time">
          {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
        </h2>
      </div>
    </router-link>
    <div class="decor-shield"></div>
  </div>
</template>
<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "FirstBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.first-Bar {
  position: relative;
  margin: 0 2rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-areas:
    "card-2 card-1 card-1 card-4"
    "card-3 card-1 card-1 card-5";
  grid-row-gap: 2.25em;
  .card {
    position: relative;
    color: #fff;
    .image-block {
      position: relative;
      background: #60657d;
      border-radius: 310.5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .category {
        position: relative;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 2em;
        text-align: center;
        opacity: 0.7;
        text-transform: uppercase;
        // letter-spacing: 0.125rem;
      }
      .image {
        position: relative;
        aspect-ratio: 4/3;
      }
    }
    .about {
      position: relative;
      text-align: center;
      line-height: 1.3;
      font-style: normal;
      .category-alter {
        display: none;
      }
      .text {
        position: relative;
        font-family: Roboto;
        font-weight: 500;
        font-size: 2.3em;
        --snup: 2;
        display: -webkit-box;
        -webkit-line-clamp: var(--snup);
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .time {
        position: relative;
        font-family: Open Sans;
        font-weight: 300;
        font-size: 2em;
        opacity: 0.8;
      }
    }
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4),
    &:nth-child(5) {
      max-width: 100%;
      .image-block {
        .image {
          max-width: 90%;
          border-radius: 400px;
        }
        .category {
          line-height: 1.5;
        }
      }
      .about {
        margin: 0.6rem 1.1rem 0 1.1rem;
        .text {
          margin-bottom: 0.5rem;
        }
      }
    }
    &:nth-child(1) {
      align-self: center;
      // max-width: 828px;
      margin: 0 auto;
      min-width: 90%;
      .image-block {
        border-radius: 40%;
        .category {
          font-size: 2.5em;
          line-height: 2;
        }
        .image {
          // max-width: 766px;
          width: 90%;
          border-radius: 550px;
        }
      }
      .about {
        margin: 1rem 4.35rem 0 4.35rem;
        .text {
          font-size: 3em;
          margin-bottom: 0.6rem;
        }
        .time {
          font-size: 2.2em;
        }
      }
    }
  }
}
@media screen and (max-width: 2900px) {
  .first-Bar {
    .card {
      .image-block {
        .category {
          font-size: 1.3em;
        }
      }
      .about {
        .text {
          font-size: 1.5em;
        }
        .time {
          font-size: 1.1em;
        }
      }
      &:nth-child(1) {
        .image-block {
          border-radius: 310.5px;
          .category {
            font-size: 1.4em;
          }
          .image {
            border-radius: 287.5px;
          }
        }
        .about {
          .text {
            font-size: 1.6em;
          }
          .time {
            font-size: 1.3em;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .first-Bar {
    .card {
      .image-block {
        .category {
          font-size: 1em;
        }
      }
      .about {
        .text {
          font-size: 1.19em;
        }
        .time {
          font-size: 0.88em;
        }
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        max-width: 400px;
        .image-block {
          .image {
            max-width: 370px;
            border-radius: 150px;
          }
        }
      }
      &:nth-child(1) {
        align-self: center;
        margin: 0;
        max-width: 828px;
        min-width: inherit;
        .image-block {
          border-radius: 310.5px;
          .category {
            font-size: 1.1em;
          }
          .image {
            max-width: 766px;
            border-radius: 287.5px;
          }
        }
        .about {
          .text {
            font-size: 1.5em;
          }
          .time {
            font-size: 1.1em;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 978px) {
  .first-Bar {
    margin: 0;
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
      "card-1 card-1"
      "card-1 card-1"
      "card-2 card-3"
      "card-4 card-5";
    // background-color: #60657d;
    border-radius: 500px 500px 0 0;
    .card {
      justify-self: center;
      &:nth-child(1) {
        width: 100%;
        max-width: 100%;
        align-items: center;
        .image-block {
          max-width: 100%;
          border-radius: 25.4em;
          background-color: #60657d;
          .image {
            z-index: 2;
            max-width: 100vw;
            border-radius: 367.5px;
          }

          .category {
            margin: 0.7rem 0;
            font-size: 1.3em;
            line-height: 1;
          }
        }
        .about {
          z-index: 1;
          // margin: 1rem 20% 2rem 20%;
          .decor-block {
            width: 110%;
            left: 50%;
            transform: translateX(-50%);
            position: absolute;
            background: #404051;
            border-radius: 239.5px;
            bottom: -25%;
            aspect-ratio: 650/339;
            z-index: -1;
          }
          .text {
            --snup: 2;
            font-size: 1.8em;
            margin: 0 3%;
          }
          .time {
            margin: 0.6rem 0 0;
            font-size: 1.2em;
          }
        }
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        max-width: 355px;
        .image-block {
          background: #4b4d61;
          .image {
            max-width: 328px;
            border-radius: 150px;
          }
          .category {
            line-height: 1.9;
            font-size: 1em;
          }
        }
        .about {
          .text {
            --snup: 3;
            margin: 1rem 0.5rem 0 0.5rem;
          }
          .time {
            // margin-top: 0.4rem;
            font-size: 1.2em;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .first-Bar {
    grid-row-gap: 3rem;
    .card {
      &:nth-child(1) {
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .image-block {
          width: 110%;
          max-width: 110%;
        }
        .about {
          z-index: 1;
          margin: 2% 15% 2rem 15%;
          .decor-block {
            width: 120%;
            max-width: 120%;
          }
        }
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        max-width: 355px;
        margin: 0 1rem;
        .image-block {
          background: #4b4d61;

          .image {
            max-width: 328px;
            border-radius: 150px;
          }
        }
        .about {
          .text {
            margin: 0.5rem 0.8rem 0 0.8rem;
          }
          .time {
            font-size: 1em;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 475px) {
  .first-Bar {
    grid-row-gap: 1.2rem;
    .card {
      &:nth-child(1) {
        .image-block {
          .decor-block {
            bottom: -29%;
            aspect-ratio: 359/128;
          }
          .category {
            padding: 0.2rem 0;
            font-size: 1em;
          }
        }
        .about {
          margin: 0.5rem 3rem 1rem 3rem;
          .decor-block {
            display: none;
          }
          .text {
            font-size: 1.5em;
          }
          .time {
            margin-top: 0.3rem;
            font-size: 1.3em;
          }
        }
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        margin: 0 3%;
        .image-block {
          border-radius: 150px;

          .category {
            line-height: 1.5;
            font-size: 0.9em;
            padding-top: 0.5rem;
          }
        }
        .about {
          margin: 0;
          .text {
            --snup: 3;
            margin: 0.2rem 0.5rem 0 0.5rem;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 375px) {
  .first-Bar {
    grid-template-columns: repeat(2, 50%);
    grid-row-gap: 1.5rem;
    grid-column-gap: 0;
    .card {
      &:nth-child(1) {
        .image-block {
          .decor-block {
            bottom: -30%;
            aspect-ratio: 359/128;
          }
          .category {
            margin: 0.1rem 0;
          }
        }
        .about {
          margin: 0.5rem 3rem 1rem 3rem;
          .text {
            font-size: 1.3em;
          }
          .time {
            margin-top: 0.3rem;
            font-size: 1.1em;
          }
        }
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        width: 100%;
        max-width: 170px;
        margin: 0;
        .image-block {
          margin: 0;
          max-width: 170px;
          border-radius: 150px;
          .image {
            width: 95%;
            max-width: 155px;
          }
          .category {
            line-height: 0.5;
            font-size: 0.9em;
            padding-top: 0.5rem;
            opacity: 0;
          }
        }
        .about {
          margin: 0;
          .category-alter {
            display: block;
            font-family: Open Sans;
            font-style: normal;
            font-weight: 600;
            font-size: 1em;
            line-height: 1.1;
            margin-top: 0.6rem;
            opacity: 0.7;
            text-transform: uppercase;
          }
          .text {
            --snup: 3;
            margin: 0.2rem 0.5rem 0 0.5rem;
          }
        }
      }
    }
  }
}
</style>
